import React, { Component, useState, useEffect, useMemo, useRef } from 'react';

import loadable from "@loadable/component";

import {
  BrowserRouter,
  Routes,
  createBrowserRouter,
  RouterProvider,
  Route,
  Navigate,
  useNavigate,
  useLocation,
  Link
} from 'react-router-dom';
import { withTranslation, Translation, } from 'react-i18next';

import {BrowserView,MobileView,TabletView, isMobileOnly, isTablet} from 'react-device-detect';

import PopVideo from "./components/pages/pop/PopVideo";

import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";


import i18n from "./i18n";

import LoadingPage from "./components/pages/home/LoadingPage";

const HomePage = loadable(() => import("./components/pages/home/HomePage"), {
   fallback: <LoadingPage />
});

const GuidingPrinciplesPage = loadable(() => import("./components/pages/home/GuidingPrinciplesPage"), {
   fallback: <LoadingPage />
});

const WomenPaveTheWayPage = loadable(() => import("./components/pages/home/WomenPaveTheWayPage"), {
   fallback: <LoadingPage />
});

const CallToActionPage = loadable(() => import("./components/pages/home/CallToActionPage"), {
   fallback: <LoadingPage />
});

const OpportunitesPage = loadable(() => import("./components/pages/home/OpportunitesPage"), {
   fallback: <LoadingPage />
});

const NewsletterPage = loadable(() => import("./components/pages/home/NewsletterPage"), {
   fallback: <LoadingPage />
});

const PolirePage = loadable(() => import("./components/pages/home/PolirePage"), {
   fallback: <LoadingPage />
});

const ArmeeCreativePage = loadable(() => import("./components/pages/home/ArmeeCreativePage"), {
   fallback: <LoadingPage />
});

const RejoindreArmeeCreativePage = loadable(() => import("./components/pages/home/RejoindreArmeeCreativePage"), {
   fallback: <LoadingPage />
});

const IndustrieNarrativePage = loadable(() => import("./components/pages/home/IndustrieNarrativePage"), {
   fallback: <LoadingPage />
});

const UnsubscribeNewsletterPage = loadable(() => import("./components/pages/home/UnsubscribeNewsletterPage"), {
   fallback: <LoadingPage />
});

const SignupPage = loadable(() => import("./components/pages/auth/SignupPage"), {
   fallback: <LoadingPage />
});



const NoMatch = loadable(() => import("./components/pages/home/NoMatch"), {
   fallback: <LoadingPage />
});

import OpenJobForm from "./components/pages/home/OpenJobForm";
import OpenJobFormCreative from "./components/pages/home/OpenJobFormCreative";
import OpenDiscoverMyRole from "./components/pages/home/OpenDiscoverMyRole";


const algoliasearch = require('algoliasearch');
var client = algoliasearch('HKB157K3KU', '357f2b37e5ef8c12f7b90877758ff663');


const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;

const App = () => {

  const [displayModalPop, setDisplayModalPop] = useState(false);
  const [displayModalPopCreative, setDisplayModalPopCreative] = useState(false);
  const [displayModalPopDiscoverMyRole, setDisplayModalPopDiscoverMyRole] = useState(false);
  const [bodyPos, setBodyPos] = useState(0);
  const [currentObject, setCurrentObject] = useState(null);
  const [currentBody, setCurrentBody] = useState(null);
  const [currentTitle, setCurrentTitle] = useState(null);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [displayPop, setDisplayPop] = useState('none');

  const videoRef = useRef(null);

  useEffect(() => {

        i18n.changeLanguage('fr');


        window.onorientationchange = (event) => {
            if (isMobileOnly || isTablet)
            {
               window.location.reload();
            }
          };


       fetch('https://api.ipstack.com/check?access_key=9cd4ffbf45a257de9e644d4d875a9465')
            .then((response) => response.json())
            .then((responseData) => {
                 //alert("App. Store: " + JSON.stringify(responseData));

                 global.country = responseData.country_code;
                 global.continent = responseData.continent_code;
                 global.ip = responseData.ip;

                 if (localStorage.getItem("language"))
                 {
                  //  i18n.changeLanguage(localStorage.getItem("language"));
                 }
                 else
                 {
                     if (global.country === 'CD' || global.country === 'FR' || global.country === 'BE' || global.country === 'TG' || global.country === 'CI')
                     {
                        // i18n.changeLanguage('fr');
                     }
                     else
                     {
                        // i18n.changeLanguage('en');
                     }
                 }




                 //alert(localStorage.getItem("language"))

              })
             .catch(function(error) {
                  // i18n.changeLanguage('en');
             });



   }, []);


   const startFillingForm = () => {
     var _bodyPos  = window.pageYOffset || document.documentElement.scrollTop;
     setBodyPos(_bodyPos);



     window.scrollTo(0, 0);

     setDisplayModalPop(true);

   }


   const discoverMyRole = () => {
     var _bodyPos  = window.pageYOffset || document.documentElement.scrollTop;
     setBodyPos(_bodyPos);



     window.scrollTo(0, 0);

     setDisplayModalPopDiscoverMyRole(true);

     //document.body.style.overflow = 'hidden';

   }


   const startFillingFormCreative = () => {
     var _bodyPos  = window.pageYOffset || document.documentElement.scrollTop;
     setBodyPos(_bodyPos);



     window.scrollTo(0, 0);

     setDisplayModalPopCreative(true);

   }

   const quitStartFillingForm = () => {

     //alert(bodyPos);

     document.body.style.overflow = '';
     window.scrollTo(0, bodyPos);

     setDisplayModalPop(false);

     setTimeout(function(){
       window.scrollTo(0, bodyPos);
     }, 100);


   }



   const quitStartFillingFormCreative = () => {

     //alert(bodyPos);

     document.body.style.overflow = '';
     window.scrollTo(0, bodyPos);

     setDisplayModalPopCreative(false);

     setTimeout(function(){
       window.scrollTo(0, bodyPos);
     }, 100);


   }


   const quitDiscoverMyRole = () => {

     //alert(bodyPos);

     document.body.style.overflow = '';
     window.scrollTo(0, bodyPos);

     setDisplayModalPopDiscoverMyRole(false);

     setTimeout(function(){
       window.scrollTo(0, bodyPos);
     }, 100);


   }


   const previewPop = (name) => {
     var _bodyPos  = window.pageYOffset || document.documentElement.scrollTop;

     setDisplayPop(name);
     setBodyPos(_bodyPos);


     document.body.style.overflow = 'hidden';
   }


   const quitDisplayPop = () => {
       document.body.style.overflow = '';

       setDisplayPop('none');
       setCurrentObject(null);
       setCurrentBody(null);

   }


   const onPreviewVideo = (poster, url) => {
     //setSelectedVideo(v);
     previewPop('Video');

     setTimeout(() => {
       if (videoRef.current) {
         videoRef.current.displayInnerDiv(poster, url);
       }
     }, 100);
   }


   return (
     <Translation>
       {
           t =>
           <BrowserRouter>

            <Header/>

            {displayModalPop &&
              <OpenJobForm quitStartFillingForm={quitStartFillingForm}/>
            }

            {displayModalPopCreative &&
              <OpenJobFormCreative quitStartFillingFormCreative={quitStartFillingFormCreative}/>
            }

            {displayModalPopDiscoverMyRole &&
              <OpenDiscoverMyRole quitDiscoverMyRole={quitDiscoverMyRole} joinCreativeArmy={startFillingFormCreative}/>
            }

            {displayPop === 'Video' &&  <PopVideo ref={videoRef} onClose={quitDisplayPop}/>}

            {!displayModalPop && !displayModalPopCreative && !displayModalPopDiscoverMyRole &&
             <Routes>
               <Route path="/" element={<HomePage onPreviewVideo={onPreviewVideo} startFillingFormCreative={startFillingFormCreative} discoverMyRole={discoverMyRole}/>} />
               <Route path="/ac/signup" element={<SignupPage />} />
               <Route path="/guiding-principles" element={<GuidingPrinciplesPage />} />
               <Route path="/principes-directeurs" element={<GuidingPrinciplesPage />} />
               <Route path="/women-pave-the-way" element={<WomenPaveTheWayPage />} />
               <Route path="/les-femmes" element={<WomenPaveTheWayPage />} />
               <Route path="/polire" element={<PolirePage />} />
               <Route path="/appel-a-l-action" element={<CallToActionPage startFillingForm={startFillingForm}/>} />
               <Route path="/opportunites" element={<OpportunitesPage startFillingForm={startFillingForm} />} />
               <Route path="/newsletter/se-desabonner" element={<UnsubscribeNewsletterPage />} />
               <Route path="/newsletter" element={<NewsletterPage />} />
               <Route path="/armee-creative" element={<ArmeeCreativePage onPreviewVideo={onPreviewVideo} startFillingFormCreative={startFillingFormCreative}/>} />
               <Route path="/armee-creative/rejoindre" element={<RejoindreArmeeCreativePage startFillingForm={startFillingForm}/>} />
               <Route path="/industrie-narrative" element={<IndustrieNarrativePage onPreviewVideo={onPreviewVideo} startFillingFormCreative={startFillingFormCreative} discoverMyRole={discoverMyRole}/>} />
               <Route path="*" element={<NoMatch />} />
             </Routes>
           }


           <Footer />



           </BrowserRouter>
        }
    </Translation>
  );

}

export default App;
